import { Color } from '@tmh-website/shared/colors';
import theme from '@tmh-website/styles/theme';
import transparentize from 'polished/lib/color/transparentize';

export type ScrollbarThemeColor =
  | Color.Neutral_0_White
  | Color.Neutral_200_OffWhite
  | Color.Blue_900
  | Color.Blue_1000_Deep;

/**
 * We use strings instead of Color here because we need very subtle variations of the colors
 * and can't achieve that with the Color enum.
 */

interface ScrollbarTheme {
  track: string;
  thumb: {
    normal: string;
    hover: string;
  };
}

export const scrollbarThemes: { [key in ScrollbarThemeColor]: ScrollbarTheme } = {
  [Color.Neutral_0_White]: {
    track: transparentize(0.9, theme.color[Color.Blue_1000_Deep]),
    thumb: {
      normal: transparentize(0.9, theme.color[Color.Blue_1000_Deep]),
      hover: transparentize(0.8, theme.color[Color.Blue_1000_Deep]),
    },
  },
  [Color.Neutral_200_OffWhite]: {
    track: transparentize(0.9, theme.color[Color.Blue_1000_Deep]),
    thumb: {
      normal: transparentize(0.9, theme.color[Color.Blue_1000_Deep]),
      hover: transparentize(0.8, theme.color[Color.Blue_1000_Deep]),
    },
  },
  [Color.Blue_900]: {
    track: transparentize(0.95, theme.color[Color.Neutral_0_White]),
    thumb: {
      normal: transparentize(0.9, theme.color[Color.Neutral_0_White]),
      hover: transparentize(0.75, theme.color[Color.Neutral_0_White]),
    },
  },
  [Color.Blue_1000_Deep]: {
    track: transparentize(0.9, theme.color[Color.Neutral_0_White]),
    thumb: {
      normal: transparentize(0.9, theme.color[Color.Neutral_0_White]),
      hover: transparentize(0.75, theme.color[Color.Neutral_0_White]),
    },
  },
};
